import React, { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import logo from '../Ecomphotos/ori.png';

function Navr() {
  // Mobile menu close karne ke liye state
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <>
      {/* Sticky Top lagaya taaki scroll karne par bhi navbar upar dikhe */}
      <nav className="navbar navbar-expand-lg main-navbar sticky-top">
        <div className="container">
          
          {/* Logo Section */}
          <NavLink className="navbar-brand" to="/" onClick={closeMenu}>
            <img
              src={logo}
              alt="Jawali Holidays Logo"
              className="logo-img"
            />
          </NavLink>

          {/* Custom Hamburger Button */}
          <button
            className={`navbar-toggler ${isOpen ? "" : "collapsed"}`}
            type="button"
            onClick={toggleMenu}
            aria-controls="navbarNav"
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
          >
            <span className="toggler-icon top-bar"></span>
            <span className="toggler-icon middle-bar"></span>
            <span className="toggler-icon bottom-bar"></span>
          </button>

          {/* Navigation Links */}
          <div className={`collapse navbar-collapse justify-content-end ${isOpen ? "show" : ""}`} id="navbarNav">
            <ul className="navbar-nav align-items-center">
              {[
                { path: "/", label: "Home" },
                { path: "/About", label: "About" },
                { path: "/Services", label: "Services" },
                { path: "/Packages", label: "Packages" },
                { path: "/Contact", label: "Contact" }
              ].map((item) => (
                <li className="nav-item" key={item.label}>
                  <NavLink 
                    to={item.path} 
                    className={({ isActive }) => isActive ? "nav-link custom-link active-link" : "nav-link custom-link"}
                    onClick={closeMenu} // Mobile me click karte hi menu band ho jayega
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
              
           
            </ul>
          </div>
        </div>
      </nav>

      <Outlet />
    </>
  );
}

export default Navr;